import { Button, Tooltip } from "@mui/material";
import React from "react";
import FactoryOne from "../../../assets/paypalOne.png";
import FactoryTwo from "../../../assets/paypal2.png";
import FactoryThree from "../../../assets/factoryIcon.png";
import SizingIcon from "../../../assets/sizingTableIcon.png";
import Placeholder from "../../../assets/placeholder.jpg";
import ExtraRequestMessages from "./ExtraRequestMessages";
import { VideoPlayModal } from "../../../../../components/VideoPlayModal";
import ReactPlayer from "react-player";

export default function NewExtraRequestWithMessaging({
  product,
  boxShadow,
  handleClose,
}) {
  const client_note = product?.quotation_request?.additional_notes?.client_note;
  const admin_note = product?.quotation_request?.additional_notes?.admin_note;
  const TooltipBasedOnPicture = (product, title, mimeType) => (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#ffff",
            maxWidth: "450px",
            width: "auto",
            boxShadow:
              "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
            color: "black",
            fontSize: "13px",
            fontWeight: 500,
            padding: "15px",
            textAlign: "left",
          },
        },
        arrow: {
          sx: {
            fontSize: 16,
            color: "#ffff",
          },
        },
      }}
      title={
        !mimeType || mimeType === "image/jpeg" || mimeType === "image/png"  ? (
          <div style={{ textAlign: "center" }}>
            <img
              src={
                title === "Factory Picture"
                  ? product?.factory_picture
                  : title === "Sizing table"
                  ? product?.sizing_table
                  : Placeholder
              }
              alt="factory_picture"
              style={{ width: "100%" }}
            />
          </div>
        ) : (
          <div style={{ width: "100%" }}>
            <ReactPlayer
              url={
                title === "Factory Picture" || title === "Factory Video"
                  ? product?.factory_picture
                  : product?.sizing_table
              }
              controls={true}
              width="100%"
              height="100%"
              playing="true"
            />
          </div>
        )
      }
      placement="top"
      style={{ color: "tomato" }}
      arrow
    >
      <a
        href={
          title === "Factory Picture"
            ? product?.factory_picture
            : product?.sizing_table
        }
        target="_blank"
        rel="noreferrer"
        style={{ color: "#7f56d9", cursor: "pointer" }}
      >
        <>
          {" "}
          <span style={{ color: "black", fontWeight: 400 }}>View </span>
          {title}
        </>
      </a>
    </Tooltip>
  );
  return (
    <>
      <div style={{ boxShadow: boxShadow, borderRadius: "5px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginTop: "20px",
            padding: "20px",
            borderRadius: "7.5px",
          }}
        >
          <img
            src={product?.images[0]?.src || Placeholder}
            alt="productimage"
            style={{ width: "40px", height: "40px", borderRadius: "5px" }}
          />
          <h4 style={{ fontSize: "16px", marginLeft: "20px" }}>
            {product?.title || "N/A"}
          </h4>
        </div>
        {product?.quotation_request?.options?.option1 && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              padding: "5px 20px",
              borderRadius: "7.5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                  marginTop: "5px",
                }}
              >
                <img src={FactoryOne} alt="page_image" />
                <img
                  src={FactoryTwo}
                  alt="page_image"
                  style={{ marginTop: -33, marginBottom: "20px" }}
                />
                <img
                  src={FactoryThree}
                  alt="page_image"
                  style={{ marginTop: -45, marginBottom: "20px" }}
                />
              </div>
              <div>
                <h4 style={{ fontSize: "16px", lineHeight: 1.5 }}>
                  Factory product pictures
                </h4>
                <h6 style={{ marginTop: 0, marginBottom: 0 }}>
                  {!product?.factory_picture ? (
                    <h6 style={{ color: "black", marginTop: 10 }}>
                      Factory picture is
                      <strong
                        style={{
                          color: "#FF7F7F",
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {" "}
                        not available
                      </strong>
                    </h6>
                  ) : (
                    TooltipBasedOnPicture(
                      product,
                      product?.quotation_request?.options?.option1MimeType?.startsWith("image/") 
                        ? "Factory Picture"
                        : "Factory Video",
                      product?.quotation_request?.options?.option1MimeType
                    )
                  )}
                </h6>
              </div>
            </div>
          </div>
        )}
        {product?.quotation_request?.options?.option2 && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              padding: "5px 20px",
              borderRadius: "7.5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                  marginTop: "5px",
                }}
              >
                <img src={FactoryOne} alt="page_image" />
                <img
                  src={FactoryTwo}
                  alt="page_image"
                  style={{ marginTop: -33, marginBottom: "20px" }}
                />
                <img
                  src={SizingIcon}
                  alt="page_image"
                  style={{ marginTop: -45, marginBottom: "20px" }}
                />
              </div>
              <div>
                <h4 style={{ fontSize: "16px", lineHeight: 1.5 }}>
                  Sizing table
                </h4>
                <h6 style={{ marginTop: 0 }}>
                  {!product?.sizing_table ? (
                    <h6 style={{ color: "black", marginTop: 10 }}>
                      Sizing table is
                      <strong
                        style={{
                          color: "#FF7F7F",
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {" "}
                        not available
                      </strong>
                    </h6>
                  ) : (
                    TooltipBasedOnPicture(
                      product,
                      product?.quotation_request?.options?.option2MimeType?.startsWith("image/")
                        ? "Sizing table"
                        : "Sizing table video",
                      product?.quotation_request?.options?.option2MimeType
                    )
                  )}
                </h6>
              </div>
            </div>
          </div>
        )}
      </div>
      {(client_note || admin_note) && (
        <div
          style={{
            boxShadow: boxShadow,
            borderRadius: "5px",
            padding: "20px 0px",
            marginTop: "20px",
          }}
        >
          <ExtraRequestMessages product={product} />
        </div>
      )}

      <div style={{ textAlign: "right" }}>
        <Button
          onClick={handleClose}
          variant="lightblue"
          sx={{
            width: "auto",
            marginTop: "50px",
            marginBottom: 0,
            background: "#210C43",
            boxShadow: "none",
            ":hover": {
              background: "#210C43",
            },
          }}
        >
          Close
        </Button>
      </div>
    </>
  );
}
